import React, { useMemo } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PROFILE } from '../../../../constants/strings';
import { DEVICE_CALENDAR_FORMATS } from '../../../PatientHealthboard/constants';
import { formatToCalendarTime } from '../../../PatientHealthboard/utils';
import styles from './index.styl';

export const Device = ({ device, providerEmail }) => {
  const { name, syncedAt, provider } = device;
  const title = providerEmail || `${provider.name} ${name}`;

  const titleStyles = useMemo(
    () => cn(styles.title, { [styles.capitalize]: !providerEmail }),
    [providerEmail],
  );

  return (
    <div className={styles.root}>
      <div className={titleStyles}>{title}</div>
      <div className={styles.syncedDate}>
        <FormattedMessage {...PROFILE.deviceSetup.synced} />
        {formatToCalendarTime(syncedAt, false, DEVICE_CALENDAR_FORMATS)}
      </div>
    </div>
  );
};

Device.propTypes = {
  device: PropTypes.object,
  providerEmail: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeviceSetup/Device/index.jsx